// ============================================================
// OMYA Digital Plant – Centralized Mock Data
// All entities are interconnected via IDs for cross-page navigation
// ============================================================

// ── Current User ──────────────────────────────────────────

export const currentUser = {
  name: 'Petr Nebesař',
  role: 'Operations Manager',
  initials: 'PN',
  email: 'petr.nebesar@omya.com',
  plant: 'Pomezí',
};

// ── Supply Chain Nodes ──────────────────────────────────────

export const supplyChainNodes = [
  {
    id: 'node-quarry',
    label: 'Quarry',
    type: 'quarry',
    icon: 'Mountain',
    position: { x: 80, y: 200 },
    status: 'ok',
    capacity: { max: 320, current: 237, unit: 't/h' },
    utilization: 74,
    oee: { availability: 92, performance: 85, quality: 99.2, overall: 77.6 },
    equipment: {
      manufacturer: 'Metso Outotec',
      model: 'Lokotrack LT120E',
      yearInstalled: 2019,
      lastMaintenance: '2024-06-01',
      nextMaintenance: '2024-07-15',
      hoursRun: 12450,
    },
    currentBatch: {
      material: 'Limestone GCC',
      orderId: 'ORD-2024-1847',
      startedAt: '2024-06-15T06:00:00',
      targetTons: 240,
      producedTons: 178,
    },
    alerts: [
      { id: 'a-q1', severity: 'warning', message: 'mock.nodeAlert.vibrationOverThreshold', timestamp: '2024-06-15T10:23:00' },
    ],
    maintenanceHistory: [
      { date: '2024-06-01', type: 'Scheduled', description: 'Belt replacement + lubrication', duration: '4h' },
      { date: '2024-04-12', type: 'Unplanned', description: 'Hydraulic pump failure', duration: '8h' },
      { date: '2024-02-20', type: 'Scheduled', description: 'Annual inspection', duration: '12h' },
    ],
    history24h: [
      { hour: '00:00', output: 0 }, { hour: '01:00', output: 0 }, { hour: '02:00', output: 0 },
      { hour: '03:00', output: 0 }, { hour: '04:00', output: 0 }, { hour: '05:00', output: 0 },
      { hour: '06:00', output: 180 }, { hour: '07:00', output: 210 }, { hour: '08:00', output: 225 },
      { hour: '09:00', output: 237 }, { hour: '10:00', output: 237 }, { hour: '11:00', output: 230 },
      { hour: '12:00', output: 200 }, { hour: '13:00', output: 215 }, { hour: '14:00', output: 237 },
      { hour: '15:00', output: 240 }, { hour: '16:00', output: 235 }, { hour: '17:00', output: 220 },
      { hour: '18:00', output: 190 }, { hour: '19:00', output: 150 }, { hour: '20:00', output: 0 },
      { hour: '21:00', output: 0 }, { hour: '22:00', output: 0 }, { hour: '23:00', output: 0 },
    ],
    historyWeek: [
      { day: 'Po', actual: 2100, target: 2400 },
      { day: 'Út', actual: 2250, target: 2400 },
      { day: 'St', actual: 2380, target: 2400 },
      { day: 'Čt', actual: 2150, target: 2400 },
      { day: 'Pá', actual: 2300, target: 2400 },
      { day: 'So', actual: 1600, target: 1800 },
      { day: 'Ne', actual: 1847, target: 2000 },
    ],
    linkedOrders: ['ORD-2024-1847', 'ORD-2024-1844', 'ORD-2024-1842'],
  },
  {
    id: 'node-crusher',
    label: 'Crusher',
    type: 'crusher',
    icon: 'Settings2',
    position: { x: 380, y: 200 },
    status: 'warning',
    capacity: { max: 280, current: 230, unit: 't/h' },
    utilization: 82,
    oee: { availability: 88, performance: 90, quality: 98.5, overall: 78.0 },
    equipment: {
      manufacturer: 'Sandvik',
      model: 'CH870i',
      yearInstalled: 2020,
      lastMaintenance: '2024-05-20',
      nextMaintenance: '2024-07-01',
      hoursRun: 9800,
    },
    currentBatch: {
      material: 'Limestone GCC',
      orderId: 'ORD-2024-1847',
      startedAt: '2024-06-15T06:30:00',
      targetTons: 240,
      producedTons: 165,
    },
    alerts: [
      { id: 'a-c1', severity: 'warning', message: 'mock.nodeAlert.bearingTemp78', timestamp: '2024-06-15T09:45:00' },
      { id: 'a-c2', severity: 'warning', message: 'mock.nodeAlert.crusherChamberWear72', timestamp: '2024-06-15T08:00:00' },
    ],
    maintenanceHistory: [
      { date: '2024-05-20', type: 'Scheduled', description: 'Liner replacement', duration: '6h' },
      { date: '2024-03-15', type: 'Scheduled', description: 'Bearing inspection', duration: '3h' },
      { date: '2024-01-10', type: 'Unplanned', description: 'Tramp iron damage', duration: '16h' },
    ],
    history24h: [
      { hour: '00:00', output: 0 }, { hour: '01:00', output: 0 }, { hour: '02:00', output: 0 },
      { hour: '03:00', output: 0 }, { hour: '04:00', output: 0 }, { hour: '05:00', output: 0 },
      { hour: '06:00', output: 160 }, { hour: '07:00', output: 200 }, { hour: '08:00', output: 220 },
      { hour: '09:00', output: 230 }, { hour: '10:00', output: 225 }, { hour: '11:00', output: 218 },
      { hour: '12:00', output: 195 }, { hour: '13:00', output: 210 }, { hour: '14:00', output: 230 },
      { hour: '15:00', output: 228 }, { hour: '16:00', output: 215 }, { hour: '17:00', output: 200 },
      { hour: '18:00', output: 180 }, { hour: '19:00', output: 140 }, { hour: '20:00', output: 0 },
      { hour: '21:00', output: 0 }, { hour: '22:00', output: 0 }, { hour: '23:00', output: 0 },
    ],
    historyWeek: [
      { day: 'Po', actual: 1950, target: 2200 },
      { day: 'Út', actual: 2050, target: 2200 },
      { day: 'St', actual: 2180, target: 2200 },
      { day: 'Čt', actual: 1900, target: 2200 },
      { day: 'Pá', actual: 2100, target: 2200 },
      { day: 'So', actual: 1400, target: 1600 },
      { day: 'Ne', actual: 1700, target: 1800 },
    ],
    linkedOrders: ['ORD-2024-1847', 'ORD-2024-1846', 'ORD-2024-1844'],
  },
  {
    id: 'node-sorting',
    label: 'Sorting',
    type: 'sorting',
    icon: 'Filter',
    position: { x: 680, y: 200 },
    status: 'ok',
    capacity: { max: 260, current: 177, unit: 't/h' },
    utilization: 68,
    oee: { availability: 95, performance: 78, quality: 99.5, overall: 73.7 },
    equipment: {
      manufacturer: 'Haver & Boecker',
      model: 'Niagara XL-Class',
      yearInstalled: 2021,
      lastMaintenance: '2024-05-10',
      nextMaintenance: '2024-08-10',
      hoursRun: 7200,
    },
    currentBatch: {
      material: 'Limestone GCC',
      orderId: 'ORD-2024-1847',
      startedAt: '2024-06-15T07:00:00',
      targetTons: 240,
      producedTons: 142,
    },
    alerts: [],
    maintenanceHistory: [
      { date: '2024-05-10', type: 'Scheduled', description: 'Screen mesh replacement', duration: '3h' },
      { date: '2024-02-28', type: 'Scheduled', description: 'Vibration motor check', duration: '2h' },
    ],
    history24h: [
      { hour: '00:00', output: 0 }, { hour: '01:00', output: 0 }, { hour: '02:00', output: 0 },
      { hour: '03:00', output: 0 }, { hour: '04:00', output: 0 }, { hour: '05:00', output: 0 },
      { hour: '06:00', output: 120 }, { hour: '07:00', output: 155 }, { hour: '08:00', output: 170 },
      { hour: '09:00', output: 177 }, { hour: '10:00', output: 175 }, { hour: '11:00', output: 168 },
      { hour: '12:00', output: 150 }, { hour: '13:00', output: 160 }, { hour: '14:00', output: 177 },
      { hour: '15:00', output: 180 }, { hour: '16:00', output: 172 }, { hour: '17:00', output: 160 },
      { hour: '18:00', output: 140 }, { hour: '19:00', output: 110 }, { hour: '20:00', output: 0 },
      { hour: '21:00', output: 0 }, { hour: '22:00', output: 0 }, { hour: '23:00', output: 0 },
    ],
    historyWeek: [
      { day: 'Po', actual: 1700, target: 2000 },
      { day: 'Út', actual: 1800, target: 2000 },
      { day: 'St', actual: 1950, target: 2000 },
      { day: 'Čt', actual: 1650, target: 2000 },
      { day: 'Pá', actual: 1900, target: 2000 },
      { day: 'So', actual: 1200, target: 1400 },
      { day: 'Ne', actual: 1500, target: 1600 },
    ],
    linkedOrders: ['ORD-2024-1847', 'ORD-2024-1845'],
  },
  {
    id: 'node-packaging',
    label: 'Packaging',
    type: 'packaging',
    icon: 'Package',
    position: { x: 980, y: 100 },
    status: 'ok',
    capacity: { max: 120, current: 66, unit: 't/h' },
    utilization: 55,
    oee: { availability: 90, performance: 70, quality: 99.8, overall: 62.9 },
    equipment: {
      manufacturer: 'BEUMER Group',
      model: 'BEUMER fillpac R',
      yearInstalled: 2022,
      lastMaintenance: '2024-04-25',
      nextMaintenance: '2024-07-25',
      hoursRun: 4800,
    },
    currentBatch: {
      material: 'Limestone PCC',
      orderId: 'ORD-2024-1846',
      startedAt: '2024-06-15T08:00:00',
      targetTons: 180,
      producedTons: 95,
    },
    alerts: [],
    maintenanceHistory: [
      { date: '2024-04-25', type: 'Scheduled', description: 'Bag sealing unit calibration', duration: '2h' },
      { date: '2024-01-30', type: 'Scheduled', description: 'Conveyor belt inspection', duration: '3h' },
    ],
    history24h: [
      { hour: '00:00', output: 0 }, { hour: '01:00', output: 0 }, { hour: '02:00', output: 0 },
      { hour: '03:00', output: 0 }, { hour: '04:00', output: 0 }, { hour: '05:00', output: 0 },
      { hour: '06:00', output: 40 }, { hour: '07:00', output: 55 }, { hour: '08:00', output: 62 },
      { hour: '09:00', output: 66 }, { hour: '10:00', output: 65 }, { hour: '11:00', output: 60 },
      { hour: '12:00', output: 50 }, { hour: '13:00', output: 58 }, { hour: '14:00', output: 66 },
      { hour: '15:00', output: 68 }, { hour: '16:00', output: 64 }, { hour: '17:00', output: 55 },
      { hour: '18:00', output: 42 }, { hour: '19:00', output: 30 }, { hour: '20:00', output: 0 },
      { hour: '21:00', output: 0 }, { hour: '22:00', output: 0 }, { hour: '23:00', output: 0 },
    ],
    historyWeek: [
      { day: 'Po', actual: 680, target: 900 },
      { day: 'Út', actual: 720, target: 900 },
      { day: 'St', actual: 850, target: 900 },
      { day: 'Čt', actual: 640, target: 900 },
      { day: 'Pá', actual: 780, target: 900 },
      { day: 'So', actual: 500, target: 600 },
      { day: 'Ne', actual: 550, target: 700 },
    ],
    linkedOrders: ['ORD-2024-1846', 'ORD-2024-1843'],
  },
  {
    id: 'node-bulk',
    label: 'Bulk',
    type: 'bulk',
    icon: 'Container',
    position: { x: 980, y: 300 },
    status: 'ok',
    capacity: { max: 180, current: 131, unit: 't/h' },
    utilization: 73,
    oee: { availability: 94, performance: 82, quality: 99.0, overall: 76.4 },
    equipment: {
      manufacturer: 'FLSmidth',
      model: 'PFISTER TRW-S',
      yearInstalled: 2020,
      lastMaintenance: '2024-05-15',
      nextMaintenance: '2024-08-15',
      hoursRun: 8900,
    },
    currentBatch: {
      material: 'Limestone GCC',
      orderId: 'ORD-2024-1844',
      startedAt: '2024-06-15T07:30:00',
      targetTons: 150,
      producedTons: 110,
    },
    alerts: [],
    maintenanceHistory: [
      { date: '2024-05-15', type: 'Scheduled', description: 'Silo cleaning + sensor calibration', duration: '5h' },
      { date: '2024-03-01', type: 'Unplanned', description: 'Rotary valve jam', duration: '2h' },
    ],
    history24h: [
      { hour: '00:00', output: 0 }, { hour: '01:00', output: 0 }, { hour: '02:00', output: 0 },
      { hour: '03:00', output: 0 }, { hour: '04:00', output: 0 }, { hour: '05:00', output: 0 },
      { hour: '06:00', output: 90 }, { hour: '07:00', output: 115 }, { hour: '08:00', output: 125 },
      { hour: '09:00', output: 131 }, { hour: '10:00', output: 130 }, { hour: '11:00', output: 125 },
      { hour: '12:00', output: 110 }, { hour: '13:00', output: 120 }, { hour: '14:00', output: 131 },
      { hour: '15:00', output: 135 }, { hour: '16:00', output: 128 }, { hour: '17:00', output: 115 },
      { hour: '18:00', output: 95 }, { hour: '19:00', output: 70 }, { hour: '20:00', output: 0 },
      { hour: '21:00', output: 0 }, { hour: '22:00', output: 0 }, { hour: '23:00', output: 0 },
    ],
    historyWeek: [
      { day: 'Po', actual: 1350, target: 1500 },
      { day: 'Út', actual: 1420, target: 1500 },
      { day: 'St', actual: 1480, target: 1500 },
      { day: 'Čt', actual: 1300, target: 1500 },
      { day: 'Pá', actual: 1450, target: 1500 },
      { day: 'So', actual: 900, target: 1100 },
      { day: 'Ne', actual: 1100, target: 1200 },
    ],
    linkedOrders: ['ORD-2024-1844', 'ORD-2024-1842', 'ORD-2024-1845'],
  },
  {
    id: 'node-dispatch',
    label: 'Dispatch',
    type: 'dispatch',
    icon: 'Truck',
    position: { x: 1280, y: 200 },
    status: 'ok',
    capacity: { max: 350, current: 217, unit: 't/h' },
    utilization: 62,
    oee: { availability: 96, performance: 72, quality: 99.9, overall: 69.1 },
    equipment: {
      manufacturer: 'Liebherr',
      model: 'LTM 1300-6.3',
      yearInstalled: 2018,
      lastMaintenance: '2024-06-05',
      nextMaintenance: '2024-09-05',
      hoursRun: 15200,
    },
    currentBatch: {
      material: 'Limestone GCC',
      orderId: 'ORD-2024-1847',
      startedAt: '2024-06-15T09:00:00',
      targetTons: 240,
      producedTons: 88,
    },
    alerts: [],
    maintenanceHistory: [
      { date: '2024-06-05', type: 'Scheduled', description: 'Loading arm hydraulics service', duration: '4h' },
      { date: '2024-04-01', type: 'Scheduled', description: 'Scale calibration', duration: '1h' },
    ],
    history24h: [
      { hour: '00:00', output: 0 }, { hour: '01:00', output: 0 }, { hour: '02:00', output: 0 },
      { hour: '03:00', output: 0 }, { hour: '04:00', output: 0 }, { hour: '05:00', output: 0 },
      { hour: '06:00', output: 0 }, { hour: '07:00', output: 80 }, { hour: '08:00', output: 160 },
      { hour: '09:00', output: 217 }, { hour: '10:00', output: 210 }, { hour: '11:00', output: 200 },
      { hour: '12:00', output: 180 }, { hour: '13:00', output: 195 }, { hour: '14:00', output: 217 },
      { hour: '15:00', output: 220 }, { hour: '16:00', output: 205 }, { hour: '17:00', output: 190 },
      { hour: '18:00', output: 160 }, { hour: '19:00', output: 120 }, { hour: '20:00', output: 0 },
      { hour: '21:00', output: 0 }, { hour: '22:00', output: 0 }, { hour: '23:00', output: 0 },
    ],
    historyWeek: [
      { day: 'Po', actual: 1800, target: 2600 },
      { day: 'Út', actual: 2100, target: 2600 },
      { day: 'St', actual: 2500, target: 2600 },
      { day: 'Čt', actual: 1900, target: 2600 },
      { day: 'Pá', actual: 2400, target: 2600 },
      { day: 'So', actual: 1200, target: 1500 },
      { day: 'Ne', actual: 1600, target: 1800 },
    ],
    linkedOrders: ['ORD-2024-1847', 'ORD-2024-1846', 'ORD-2024-1843', 'ORD-2024-1841'],
  },
];

// ── Supply Chain Edges ──────────────────────────────────────

export const supplyChainEdges = [
  { id: 'edge-quarry-crusher', source: 'node-quarry', target: 'node-crusher', flowRate: 237, flowRateMax: 320, material: 'Raw limestone', status: 'active' },
  { id: 'edge-crusher-sorting', source: 'node-crusher', target: 'node-sorting', flowRate: 230, flowRateMax: 280, material: 'Crushed limestone', status: 'active' },
  { id: 'edge-sorting-packaging', source: 'node-sorting', target: 'node-packaging', flowRate: 66, flowRateMax: 120, material: 'Fine grade (<2mm)', status: 'active' },
  { id: 'edge-sorting-bulk', source: 'node-sorting', target: 'node-bulk', flowRate: 111, flowRateMax: 180, material: 'Coarse grade (2-20mm)', status: 'active' },
  { id: 'edge-packaging-dispatch', source: 'node-packaging', target: 'node-dispatch', flowRate: 66, flowRateMax: 120, material: 'Bagged product', status: 'active' },
  { id: 'edge-bulk-dispatch', source: 'node-bulk', target: 'node-dispatch', flowRate: 131, flowRateMax: 180, material: 'Bulk product', status: 'active' },
];

// ── Customers ───────────────────────────────────────────────

const customers = [
  { name: 'Bohemilk s.r.o.', ico: '25123456', contact: 'Ing. Petr Horak', email: 'horak@bohemilk.cz', address: 'Opocno 5, 517 73' },
  { name: 'Stavebniny OK', ico: '27654321', contact: 'Jana Novakova', email: 'novakova@stavok.cz', address: 'Olomouc, Dolni 12' },
  { name: 'Beton Mix a.s.', ico: '26345678', contact: 'Tomas Kral', email: 'kral@betonmix.cz', address: 'Brno, Cejl 88' },
  { name: 'Trans Cargo', ico: '28987654', contact: 'Martin Fiala', email: 'fiala@transcargo.cz', address: 'Ostrava, Porubska 200' },
  { name: 'Doprava Plus', ico: '25678901', contact: 'Lukas Marek', email: 'marek@dopravaplus.cz', address: 'Hradec Kralove, Gocara 1' },
  { name: 'Cement CZ', ico: '26789012', contact: 'Eva Svobodova', email: 'svobodova@cementcz.cz', address: 'Praha 5, Radlicka 180' },
  { name: 'BuildPro s.r.o.', ico: '27890123', contact: 'Pavel Dvorak', email: 'dvorak@buildpro.cz', address: 'Liberec, Jablonecka 22' },
  { name: 'Skanska CZ', ico: '26271303', contact: 'Ing. Radek Bartos', email: 'bartos@skanska.cz', address: 'Praha 4, Karla Engelse 3201' },
  { name: 'ZAPA beton a.s.', ico: '25137026', contact: 'Michal Vesely', email: 'vesely@zapabeton.cz', address: 'Praha 5, Nad Hlinikovou 1' },
  { name: 'Holcim CZ', ico: '15660265', contact: 'Petra Hruba', email: 'hruba@holcim.cz', address: 'Praha 7, Jankovcova 1037' },
  { name: 'Eurovia CZ', ico: '45274924', contact: 'Jan Polak', email: 'polak@eurovia.cz', address: 'Praha 1, Narodni 10' },
  { name: 'Strabag a.s.', ico: '60838744', contact: 'Ales Cermak', email: 'cermak@strabag.cz', address: 'Praha 5, Na Beliance 198' },
];

// ── Orders ──────────────────────────────────────────────────

export const orders = [
  {
    id: 'ORD-2024-1847', customer: customers[0], status: 'in-production',
    createdAt: '2024-06-10T09:00:00', confirmedAt: '2024-06-10T14:30:00', requestedDelivery: '2024-06-16',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 180, unit: 't', pricePerTon: 45, produced: 120 },
      { material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 60, unit: 't', pricePerTon: 52, produced: 60 },
    ],
    totalValue: 11220, truckIds: ['truck-1', 'truck-5'], productionLineId: 'line-1', supplyChainNodeId: 'node-packaging',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0847', status: 'issued', material: 'Limestone GCC' },
      { type: 'Test Report', number: 'TR-2024-0332', status: 'pending', material: 'Limestone PCC' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-10T09:00:00', note: 'mock.note.receivedOrderEmail' },
      { status: 'confirmed', timestamp: '2024-06-10T14:30:00', note: 'mock.note.confirmedSalesTeam' },
      { status: 'in-production', timestamp: '2024-06-14T06:00:00', note: 'mock.note.productionStartedLine1' },
    ],
  },
  {
    id: 'ORD-2024-1846', customer: customers[1], status: 'dispatched',
    createdAt: '2024-06-09T11:00:00', confirmedAt: '2024-06-09T16:00:00', requestedDelivery: '2024-06-15',
    items: [
      { material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 120, unit: 't', pricePerTon: 52, produced: 120 },
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 60, unit: 't', pricePerTon: 45, produced: 60 },
    ],
    totalValue: 8940, truckIds: ['truck-3', 'truck-8'], productionLineId: 'line-2', supplyChainNodeId: 'node-packaging',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0846', status: 'issued', material: 'Limestone PCC' },
      { type: 'COA', number: 'COA-2024-0201', status: 'issued', material: 'Limestone GCC' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-09T11:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-09T16:00:00', note: 'mock.note.confirmed' },
      { status: 'in-production', timestamp: '2024-06-12T06:00:00', note: 'mock.note.productionStartedLine2' },
      { status: 'produced', timestamp: '2024-06-14T14:00:00', note: 'mock.note.productionDone' },
      { status: 'dispatched', timestamp: '2024-06-15T08:30:00', note: 'mock.note.loadedOnTruck1J4' },
    ],
  },
  {
    id: 'ORD-2024-1845', customer: customers[2], status: 'pending',
    createdAt: '2024-06-14T08:30:00', confirmedAt: null, requestedDelivery: '2024-06-20',
    items: [
      { material: 'By-product', grade: 'Cite calcium filler', quantity: 200, unit: 't', pricePerTon: 28, produced: 0 },
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 120, unit: 't', pricePerTon: 45, produced: 0 },
    ],
    totalValue: 11000, truckIds: [], productionLineId: null, supplyChainNodeId: null,
    certificates: [],
    timeline: [
      { status: 'pending', timestamp: '2024-06-14T08:30:00', note: 'mock.note.receivedOrderPortal' },
    ],
  },
  {
    id: 'ORD-2024-1844', customer: customers[3], status: 'confirmed',
    createdAt: '2024-06-13T10:00:00', confirmedAt: '2024-06-13T15:20:00', requestedDelivery: '2024-06-18',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 150, unit: 't', pricePerTon: 45, produced: 0 },
    ],
    totalValue: 6750, truckIds: ['truck-7'], productionLineId: 'line-1', supplyChainNodeId: 'node-bulk',
    certificates: [],
    timeline: [
      { status: 'pending', timestamp: '2024-06-13T10:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-13T15:20:00', note: 'mock.note.confirmedSales' },
    ],
  },
  {
    id: 'ORD-2024-1843', customer: customers[4], status: 'dispatched',
    createdAt: '2024-06-12T09:00:00', confirmedAt: '2024-06-12T11:30:00', requestedDelivery: '2024-06-14',
    items: [
      { material: 'Limestone PCC', grade: 'Omyacarb 10-AV', quantity: 200, unit: 't', pricePerTon: 55, produced: 200 },
    ],
    totalValue: 11000, truckIds: ['truck-9'], productionLineId: 'line-3', supplyChainNodeId: 'node-packaging',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0843', status: 'issued', material: 'Limestone PCC' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-12T09:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-12T11:30:00', note: 'mock.note.confirmed' },
      { status: 'in-production', timestamp: '2024-06-12T22:00:00', note: 'mock.note.nightShift' },
      { status: 'produced', timestamp: '2024-06-13T18:00:00', note: 'mock.note.productionDone' },
      { status: 'dispatched', timestamp: '2024-06-14T07:00:00', note: 'mock.note.dispatchedDopravaPlus' },
    ],
  },
  {
    id: 'ORD-2024-1842', customer: customers[5], status: 'confirmed',
    createdAt: '2024-06-13T14:00:00', confirmedAt: '2024-06-13T17:00:00', requestedDelivery: '2024-06-19',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 200, unit: 't', pricePerTon: 45, produced: 0 },
      { material: 'By-product', grade: 'CaCO3 powder', quantity: 80, unit: 't', pricePerTon: 30, produced: 0 },
    ],
    totalValue: 11400, truckIds: [], productionLineId: 'line-2', supplyChainNodeId: 'node-bulk',
    certificates: [],
    timeline: [
      { status: 'pending', timestamp: '2024-06-13T14:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-13T17:00:00', note: 'mock.note.confirmed' },
    ],
  },
  {
    id: 'ORD-2024-1841', customer: customers[6], status: 'delivered',
    createdAt: '2024-06-10T08:00:00', confirmedAt: '2024-06-10T10:00:00', requestedDelivery: '2024-06-13',
    items: [
      { material: 'By-product', grade: 'CaCO3 powder', quantity: 160, unit: 't', pricePerTon: 30, produced: 160 },
    ],
    totalValue: 4800, truckIds: ['truck-11'], productionLineId: 'line-3', supplyChainNodeId: 'node-bulk',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0841', status: 'issued', material: 'By-product' },
      { type: 'COA', number: 'COA-2024-0198', status: 'issued', material: 'By-product' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-10T08:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-10T10:00:00', note: 'mock.note.confirmed' },
      { status: 'in-production', timestamp: '2024-06-11T06:00:00', note: 'mock.note.startedLine3' },
      { status: 'produced', timestamp: '2024-06-12T16:00:00', note: 'mock.note.productionDone' },
      { status: 'dispatched', timestamp: '2024-06-12T17:30:00', note: 'mock.note.loadedDispatched' },
      { status: 'delivered', timestamp: '2024-06-13T09:00:00', note: 'mock.note.deliveredSigned' },
    ],
  },
  {
    id: 'ORD-2024-1840', customer: customers[1], status: 'pending',
    createdAt: '2024-06-14T14:00:00', confirmedAt: null, requestedDelivery: '2024-06-21',
    items: [
      { material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 150, unit: 't', pricePerTon: 52, produced: 0 },
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 70, unit: 't', pricePerTon: 45, produced: 0 },
    ],
    totalValue: 10950, truckIds: [], productionLineId: null, supplyChainNodeId: null,
    certificates: [],
    timeline: [
      { status: 'pending', timestamp: '2024-06-14T14:00:00', note: 'mock.note.receivedOrderEmail' },
    ],
  },
  {
    id: 'ORD-2024-1839', customer: customers[7], status: 'in-production',
    createdAt: '2024-06-11T09:00:00', confirmedAt: '2024-06-11T12:00:00', requestedDelivery: '2024-06-17',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 300, unit: 't', pricePerTon: 43, produced: 210 },
    ],
    totalValue: 12900, truckIds: ['truck-2', 'truck-6'], productionLineId: 'line-1', supplyChainNodeId: 'node-bulk',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0839', status: 'pending', material: 'Limestone GCC' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-11T09:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-11T12:00:00', note: 'mock.note.confirmedSales' },
      { status: 'in-production', timestamp: '2024-06-13T06:00:00', note: 'mock.note.productionStarted' },
    ],
  },
  {
    id: 'ORD-2024-1838', customer: customers[8], status: 'produced',
    createdAt: '2024-06-10T11:00:00', confirmedAt: '2024-06-10T14:00:00', requestedDelivery: '2024-06-16',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 1-AV', quantity: 250, unit: 't', pricePerTon: 48, produced: 250 },
      { material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 100, unit: 't', pricePerTon: 52, produced: 100 },
    ],
    totalValue: 17200, truckIds: ['truck-4', 'truck-10'], productionLineId: 'line-2', supplyChainNodeId: 'node-packaging',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0838', status: 'issued', material: 'Limestone GCC' },
      { type: 'Quality Certificate', number: 'QC-2024-0838b', status: 'issued', material: 'Limestone PCC' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-10T11:00:00', note: 'mock.note.receivedOrderPortal' },
      { status: 'confirmed', timestamp: '2024-06-10T14:00:00', note: 'mock.note.confirmed' },
      { status: 'in-production', timestamp: '2024-06-12T06:00:00', note: 'mock.note.productionStartedLine2' },
      { status: 'produced', timestamp: '2024-06-14T20:00:00', note: 'mock.note.productionDoneWaiting' },
    ],
  },
  {
    id: 'ORD-2024-1837', customer: customers[9], status: 'confirmed',
    createdAt: '2024-06-14T07:00:00', confirmedAt: '2024-06-14T10:00:00', requestedDelivery: '2024-06-19',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 180, unit: 't', pricePerTon: 45, produced: 0 },
    ],
    totalValue: 8100, truckIds: [], productionLineId: 'line-3', supplyChainNodeId: 'node-bulk',
    certificates: [],
    timeline: [
      { status: 'pending', timestamp: '2024-06-14T07:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-14T10:00:00', note: 'mock.note.confirmedSalesTeam' },
    ],
  },
  {
    id: 'ORD-2024-1836', customer: customers[10], status: 'in-production',
    createdAt: '2024-06-12T13:00:00', confirmedAt: '2024-06-12T16:30:00', requestedDelivery: '2024-06-18',
    items: [
      { material: 'Limestone PCC', grade: 'Omyacarb 10-AV', quantity: 220, unit: 't', pricePerTon: 55, produced: 145 },
      { material: 'By-product', grade: 'CaCO3 powder', quantity: 50, unit: 't', pricePerTon: 30, produced: 50 },
    ],
    totalValue: 13600, truckIds: ['truck-12'], productionLineId: 'line-2', supplyChainNodeId: 'node-packaging',
    certificates: [],
    timeline: [
      { status: 'pending', timestamp: '2024-06-12T13:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-12T16:30:00', note: 'mock.note.confirmed' },
      { status: 'in-production', timestamp: '2024-06-14T06:00:00', note: 'mock.note.startedLine2' },
    ],
  },
  {
    id: 'ORD-2024-1835', customer: customers[11], status: 'dispatched',
    createdAt: '2024-06-09T10:00:00', confirmedAt: '2024-06-09T13:00:00', requestedDelivery: '2024-06-14',
    items: [
      { material: 'Limestone GCC', grade: 'Omyacarb 1-AV', quantity: 400, unit: 't', pricePerTon: 43, produced: 400 },
    ],
    totalValue: 17200, truckIds: ['truck-13', 'truck-14'], productionLineId: 'line-1', supplyChainNodeId: 'node-bulk',
    certificates: [
      { type: 'Quality Certificate', number: 'QC-2024-0835', status: 'issued', material: 'Limestone GCC' },
      { type: 'COA', number: 'COA-2024-0195', status: 'issued', material: 'Limestone GCC' },
    ],
    timeline: [
      { status: 'pending', timestamp: '2024-06-09T10:00:00', note: 'mock.note.receivedOrder' },
      { status: 'confirmed', timestamp: '2024-06-09T13:00:00', note: 'mock.note.confirmed' },
      { status: 'in-production', timestamp: '2024-06-10T06:00:00', note: 'mock.note.startedLine1' },
      { status: 'produced', timestamp: '2024-06-13T18:00:00', note: 'mock.note.productionDone' },
      { status: 'dispatched', timestamp: '2024-06-14T06:30:00', note: 'mock.note.dispatchedTwoTrucks' },
    ],
  },
  // Additional orders for volume
  { id: 'ORD-2024-1834', customer: customers[0], status: 'delivered', createdAt: '2024-06-08T08:00:00', confirmedAt: '2024-06-08T10:00:00', requestedDelivery: '2024-06-12', items: [{ material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 90, unit: 't', pricePerTon: 52, produced: 90 }], totalValue: 4680, truckIds: [], productionLineId: 'line-3', supplyChainNodeId: 'node-packaging', certificates: [{ type: 'Quality Certificate', number: 'QC-2024-0834', status: 'issued', material: 'Limestone PCC' }], timeline: [{ status: 'pending', timestamp: '2024-06-08T08:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-08T10:00:00', note: 'mock.note.confirmed' }, { status: 'in-production', timestamp: '2024-06-09T06:00:00', note: 'mock.note.started' }, { status: 'produced', timestamp: '2024-06-10T18:00:00', note: 'mock.note.done' }, { status: 'dispatched', timestamp: '2024-06-11T07:00:00', note: 'mock.note.dispatched' }, { status: 'delivered', timestamp: '2024-06-12T10:00:00', note: 'mock.note.delivered' }] },
  { id: 'ORD-2024-1833', customer: customers[2], status: 'confirmed', createdAt: '2024-06-14T15:00:00', confirmedAt: '2024-06-14T17:00:00', requestedDelivery: '2024-06-20', items: [{ material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 260, unit: 't', pricePerTon: 45, produced: 0 }], totalValue: 11700, truckIds: [], productionLineId: 'line-1', supplyChainNodeId: 'node-bulk', certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-14T15:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-14T17:00:00', note: 'mock.note.confirmed' }] },
  { id: 'ORD-2024-1832', customer: customers[3], status: 'pending', createdAt: '2024-06-15T07:00:00', confirmedAt: null, requestedDelivery: '2024-06-22', items: [{ material: 'By-product', grade: 'CaCO3 powder', quantity: 300, unit: 't', pricePerTon: 28, produced: 0 }, { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 80, unit: 't', pricePerTon: 45, produced: 0 }], totalValue: 12000, truckIds: [], productionLineId: null, supplyChainNodeId: null, certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-15T07:00:00', note: 'mock.note.receivedPortal' }] },
  { id: 'ORD-2024-1831', customer: customers[4], status: 'in-production', createdAt: '2024-06-11T12:00:00', confirmedAt: '2024-06-11T15:00:00', requestedDelivery: '2024-06-17', items: [{ material: 'Limestone PCC', grade: 'Omyacarb 10-AV', quantity: 170, unit: 't', pricePerTon: 55, produced: 95 }], totalValue: 9350, truckIds: ['truck-15'], productionLineId: 'line-3', supplyChainNodeId: 'node-packaging', certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-11T12:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-11T15:00:00', note: 'mock.note.confirmed' }, { status: 'in-production', timestamp: '2024-06-13T22:00:00', note: 'mock.note.nightShift' }] },
  { id: 'ORD-2024-1830', customer: customers[5], status: 'produced', createdAt: '2024-06-09T08:00:00', confirmedAt: '2024-06-09T11:00:00', requestedDelivery: '2024-06-16', items: [{ material: 'Limestone GCC', grade: 'Omyacarb 1-AV', quantity: 180, unit: 't', pricePerTon: 48, produced: 180 }], totalValue: 8640, truckIds: [], productionLineId: 'line-1', supplyChainNodeId: 'node-bulk', certificates: [{ type: 'Quality Certificate', number: 'QC-2024-0830', status: 'issued', material: 'Limestone GCC' }], timeline: [{ status: 'pending', timestamp: '2024-06-09T08:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-09T11:00:00', note: 'mock.note.confirmed' }, { status: 'in-production', timestamp: '2024-06-11T06:00:00', note: 'mock.note.started' }, { status: 'produced', timestamp: '2024-06-14T12:00:00', note: 'mock.note.done' }] },
  { id: 'ORD-2024-1829', customer: customers[6], status: 'confirmed', createdAt: '2024-06-14T11:00:00', confirmedAt: '2024-06-14T14:00:00', requestedDelivery: '2024-06-19', items: [{ material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 130, unit: 't', pricePerTon: 52, produced: 0 }, { material: 'By-product', grade: 'CaCO3 powder', quantity: 40, unit: 't', pricePerTon: 30, produced: 0 }], totalValue: 7960, truckIds: [], productionLineId: 'line-2', supplyChainNodeId: 'node-packaging', certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-14T11:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-14T14:00:00', note: 'mock.note.confirmed' }] },
  { id: 'ORD-2024-1828', customer: customers[8], status: 'dispatched', createdAt: '2024-06-08T14:00:00', confirmedAt: '2024-06-08T16:00:00', requestedDelivery: '2024-06-13', items: [{ material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 220, unit: 't', pricePerTon: 45, produced: 220 }], totalValue: 9900, truckIds: [], productionLineId: 'line-2', supplyChainNodeId: 'node-bulk', certificates: [{ type: 'Quality Certificate', number: 'QC-2024-0828', status: 'issued', material: 'Limestone GCC' }, { type: 'COA', number: 'COA-2024-0190', status: 'issued', material: 'Limestone GCC' }], timeline: [{ status: 'pending', timestamp: '2024-06-08T14:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-08T16:00:00', note: 'mock.note.confirmed' }, { status: 'in-production', timestamp: '2024-06-10T06:00:00', note: 'mock.note.started' }, { status: 'produced', timestamp: '2024-06-12T18:00:00', note: 'mock.note.done' }, { status: 'dispatched', timestamp: '2024-06-13T07:00:00', note: 'mock.note.dispatched' }] },
  { id: 'ORD-2024-1827', customer: customers[9], status: 'delivered', createdAt: '2024-06-07T09:00:00', confirmedAt: '2024-06-07T11:00:00', requestedDelivery: '2024-06-11', items: [{ material: 'Limestone PCC', grade: 'Omyacarb 10-AV', quantity: 140, unit: 't', pricePerTon: 55, produced: 140 }], totalValue: 7700, truckIds: [], productionLineId: 'line-3', supplyChainNodeId: 'node-packaging', certificates: [{ type: 'Quality Certificate', number: 'QC-2024-0827', status: 'issued', material: 'Limestone PCC' }], timeline: [{ status: 'pending', timestamp: '2024-06-07T09:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-07T11:00:00', note: 'mock.note.confirmed' }, { status: 'in-production', timestamp: '2024-06-08T06:00:00', note: 'mock.note.started' }, { status: 'produced', timestamp: '2024-06-10T16:00:00', note: 'mock.note.done' }, { status: 'dispatched', timestamp: '2024-06-10T17:00:00', note: 'mock.note.dispatched' }, { status: 'delivered', timestamp: '2024-06-11T11:00:00', note: 'mock.note.delivered' }] },
  { id: 'ORD-2024-1826', customer: customers[10], status: 'pending', createdAt: '2024-06-15T10:00:00', confirmedAt: null, requestedDelivery: '2024-06-23', items: [{ material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 350, unit: 't', pricePerTon: 43, produced: 0 }], totalValue: 15050, truckIds: [], productionLineId: null, supplyChainNodeId: null, certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-15T10:00:00', note: 'mock.note.receivedPhone' }] },
  { id: 'ORD-2024-1825', customer: customers[11], status: 'confirmed', createdAt: '2024-06-13T16:00:00', confirmedAt: '2024-06-14T08:00:00', requestedDelivery: '2024-06-20', items: [{ material: 'Limestone GCC', grade: 'Omyacarb 1-AV', quantity: 280, unit: 't', pricePerTon: 48, produced: 0 }, { material: 'Limestone PCC', grade: 'Omyacarb 5-GU', quantity: 80, unit: 't', pricePerTon: 52, produced: 0 }], totalValue: 17600, truckIds: [], productionLineId: 'line-1', supplyChainNodeId: 'node-bulk', certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-13T16:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-14T08:00:00', note: 'mock.note.confirmed' }] },
  { id: 'ORD-2024-1824', customer: customers[0], status: 'in-production', createdAt: '2024-06-12T07:00:00', confirmedAt: '2024-06-12T09:00:00', requestedDelivery: '2024-06-17', items: [{ material: 'By-product', grade: 'CaCO3 powder', quantity: 100, unit: 't', pricePerTon: 30, produced: 75 }, { material: 'Limestone GCC', grade: 'Omyacarb 2-AV', quantity: 50, unit: 't', pricePerTon: 45, produced: 30 }], totalValue: 5250, truckIds: [], productionLineId: 'line-3', supplyChainNodeId: 'node-bulk', certificates: [], timeline: [{ status: 'pending', timestamp: '2024-06-12T07:00:00', note: 'mock.note.received' }, { status: 'confirmed', timestamp: '2024-06-12T09:00:00', note: 'mock.note.confirmed' }, { status: 'in-production', timestamp: '2024-06-14T06:00:00', note: 'mock.note.started' }] },
];

// ── Trucks ───────────────────────────────────────────────────

export const trucks = [
  {
    id: 'truck-1', plate: '4M2 3847',
    driver: { name: 'Jan Novak', phone: '+420 602 123 456' },
    company: customers[0].name, gate: 'PST', status: 'loading',
    eta: '2024-06-15T11:23:00', arrivedAt: '2024-06-15T11:20:00', loadingStartedAt: '2024-06-15T11:35:00',
    material: 'Limestone GCC', targetWeight: 24.5, currentWeight: 18.2,
    orderId: 'ORD-2024-1847', slotId: 'slot-pst-0800',
    events: [
      { time: '2024-06-15T10:00:00', event: 'mock.event.dispatch', icon: 'truck' },
      { time: '2024-06-15T11:20:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T11:25:00', event: 'mock.event.weighEmpty123', icon: 'scale' },
      { time: '2024-06-15T11:35:00', event: 'mock.event.loadingStartedPST', icon: 'loader' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0847.pdf', status: 'ready' },
      { type: 'Delivery Note', name: 'DN-1847-001.pdf', status: 'pending' },
      { type: 'Weigh Ticket', name: 'WT-2024-0612.pdf', status: 'pending' },
    ],
  },
  {
    id: 'truck-2', plate: '6A1 2290',
    driver: { name: 'Karel Benes', phone: '+420 603 234 567' },
    company: customers[7].name, gate: 'CLS', status: 'loading',
    eta: '2024-06-15T10:30:00', arrivedAt: '2024-06-15T10:25:00', loadingStartedAt: '2024-06-15T10:45:00',
    material: 'Limestone GCC', targetWeight: 26.0, currentWeight: 22.1,
    orderId: 'ORD-2024-1839', slotId: 'slot-cls-0900',
    events: [
      { time: '2024-06-15T09:00:00', event: 'mock.event.dispatch', icon: 'truck' },
      { time: '2024-06-15T10:25:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T10:30:00', event: 'mock.event.weighEmpty131', icon: 'scale' },
      { time: '2024-06-15T10:45:00', event: 'mock.event.loadingStartedCLS', icon: 'loader' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0839a.pdf', status: 'ready' },
      { type: 'Delivery Note', name: 'DN-1839-001.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-3', plate: '1J4 9921',
    driver: { name: 'Petr Dvorak', phone: '+420 604 345 678' },
    company: customers[1].name, gate: 'CLS', status: 'departed',
    eta: '2024-06-15T08:00:00', arrivedAt: '2024-06-15T07:55:00', loadingStartedAt: '2024-06-15T08:10:00',
    material: 'Limestone PCC', targetWeight: 24.0, currentWeight: 24.0,
    orderId: 'ORD-2024-1846', slotId: 'slot-cls-0800',
    events: [
      { time: '2024-06-15T06:30:00', event: 'mock.event.dispatch', icon: 'truck' },
      { time: '2024-06-15T07:55:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T08:05:00', event: 'mock.event.weighEmpty128', icon: 'scale' },
      { time: '2024-06-15T08:10:00', event: 'mock.event.loadingStartedCLS', icon: 'loader' },
      { time: '2024-06-15T09:40:00', event: 'mock.event.weighOut368', icon: 'scale' },
      { time: '2024-06-15T09:45:00', event: 'mock.event.departedFacility', icon: 'check-circle' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0846a.pdf', status: 'ready' },
      { type: 'Delivery Note', name: 'DN-1846-001.pdf', status: 'ready' },
      { type: 'Weigh Ticket', name: 'WT-2024-0610.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-4', plate: '3J8 4421',
    driver: { name: 'Martin Svoboda', phone: '+420 605 456 789' },
    company: customers[2].name, gate: 'PST', status: 'weigh-in',
    eta: '2024-06-15T12:45:00', arrivedAt: '2024-06-15T12:40:00', loadingStartedAt: null,
    material: 'Limestone GCC', targetWeight: 25.0, currentWeight: 0,
    orderId: 'ORD-2024-1838', slotId: 'slot-pst-1200',
    events: [
      { time: '2024-06-15T11:00:00', event: 'mock.event.dispatch', icon: 'truck' },
      { time: '2024-06-15T12:40:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T12:50:00', event: 'mock.event.weighInProgress', icon: 'scale' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0838a.pdf', status: 'ready' },
      { type: 'Delivery Note', name: 'DN-1838-001.pdf', status: 'pending' },
    ],
  },
  {
    id: 'truck-5', plate: '2K5 7733',
    driver: { name: 'Tomas Prochazka', phone: '+420 606 567 890' },
    company: customers[3].name, gate: 'CLS', status: 'waiting',
    eta: '2024-06-15T13:00:00', arrivedAt: '2024-06-15T12:55:00', loadingStartedAt: null,
    material: 'Limestone GCC', targetWeight: 24.0, currentWeight: 0,
    orderId: 'ORD-2024-1847', slotId: 'slot-cls-1300',
    events: [
      { time: '2024-06-15T11:30:00', event: 'mock.event.dispatch', icon: 'truck' },
      { time: '2024-06-15T12:55:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T13:00:00', event: 'mock.event.waitingGate', icon: 'clock' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0847b.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-6', plate: '5L9 2341',
    driver: { name: 'Pavel Cerny', phone: '+420 607 678 901' },
    company: customers[4].name, gate: 'PST', status: 'en-route',
    eta: '2024-06-15T14:30:00', arrivedAt: null, loadingStartedAt: null,
    material: 'Limestone GCC', targetWeight: 25.5, currentWeight: 0,
    orderId: 'ORD-2024-1839', slotId: 'slot-pst-1400',
    events: [
      { time: '2024-06-15T13:00:00', event: 'mock.event.dispatch', icon: 'truck' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0839b.pdf', status: 'pending' },
    ],
  },
  {
    id: 'truck-7', plate: '8B3 6654',
    driver: { name: 'Jiri Horak', phone: '+420 608 789 012' },
    company: customers[3].name, gate: 'CLS', status: 'en-route',
    eta: '2024-06-15T15:00:00', arrivedAt: null, loadingStartedAt: null,
    material: 'Limestone GCC', targetWeight: 26.0, currentWeight: 0,
    orderId: 'ORD-2024-1844', slotId: 'slot-cls-1500',
    events: [
      { time: '2024-06-15T13:30:00', event: 'mock.event.dispatch', icon: 'truck' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0844.pdf', status: 'pending' },
    ],
  },
  {
    id: 'truck-8', plate: '7C6 1198',
    driver: { name: 'Ondrej Kolar', phone: '+420 609 890 123' },
    company: customers[1].name, gate: 'PST', status: 'departed',
    eta: '2024-06-15T07:00:00', arrivedAt: '2024-06-15T06:55:00', loadingStartedAt: '2024-06-15T07:10:00',
    material: 'Limestone PCC', targetWeight: 23.5, currentWeight: 23.5,
    orderId: 'ORD-2024-1846', slotId: 'slot-pst-0600',
    events: [
      { time: '2024-06-15T05:30:00', event: 'mock.event.dispatch', icon: 'truck' },
      { time: '2024-06-15T06:55:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T07:00:00', event: 'mock.event.weigh130', icon: 'scale' },
      { time: '2024-06-15T07:10:00', event: 'mock.event.loadingStartedPST', icon: 'loader' },
      { time: '2024-06-15T08:30:00', event: 'mock.event.weighOut365', icon: 'scale' },
      { time: '2024-06-15T08:35:00', event: 'mock.event.departed', icon: 'check-circle' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0846b.pdf', status: 'ready' },
      { type: 'Delivery Note', name: 'DN-1846-002.pdf', status: 'ready' },
      { type: 'Weigh Ticket', name: 'WT-2024-0609.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-9', plate: '9D4 5512',
    driver: { name: 'Radek Vesely', phone: '+420 610 901 234' },
    company: customers[4].name, gate: 'CLS', status: 'departed',
    eta: '2024-06-15T09:00:00', arrivedAt: '2024-06-15T08:50:00', loadingStartedAt: '2024-06-15T09:10:00',
    material: 'Limestone PCC', targetWeight: 24.0, currentWeight: 24.0,
    orderId: 'ORD-2024-1843', slotId: 'slot-cls-0900',
    events: [
      { time: '2024-06-15T07:00:00', event: 'mock.event.dispatched', icon: 'truck' },
      { time: '2024-06-15T08:50:00', event: 'mock.event.arrived', icon: 'map-pin' },
      { time: '2024-06-15T09:00:00', event: 'mock.event.weigh125', icon: 'scale' },
      { time: '2024-06-15T09:10:00', event: 'mock.event.loadingStartedCLS', icon: 'loader' },
      { time: '2024-06-15T10:30:00', event: 'mock.event.weighOut365', icon: 'scale' },
      { time: '2024-06-15T10:35:00', event: 'mock.event.departed', icon: 'check-circle' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0843.pdf', status: 'ready' },
      { type: 'Weigh Ticket', name: 'WT-2024-0608.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-10', plate: '4E7 8830',
    driver: { name: 'Ales Navratil', phone: '+420 611 012 345' },
    company: customers[8].name, gate: 'PST', status: 'waiting',
    eta: '2024-06-15T13:30:00', arrivedAt: '2024-06-15T13:25:00', loadingStartedAt: null,
    material: 'Limestone PCC', targetWeight: 23.0, currentWeight: 0,
    orderId: 'ORD-2024-1838', slotId: 'slot-pst-1400',
    events: [
      { time: '2024-06-15T12:00:00', event: 'mock.event.dispatched', icon: 'truck' },
      { time: '2024-06-15T13:25:00', event: 'mock.event.arriveGate', icon: 'map-pin' },
      { time: '2024-06-15T13:30:00', event: 'mock.event.waitingSlot', icon: 'clock' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0838b.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-11', plate: '2F9 3347',
    driver: { name: 'Milan Fiala', phone: '+420 612 123 456' },
    company: customers[6].name, gate: 'CLS', status: 'departed',
    eta: '2024-06-12T14:00:00', arrivedAt: '2024-06-12T13:55:00', loadingStartedAt: '2024-06-12T14:10:00',
    material: 'By-product', targetWeight: 22.0, currentWeight: 22.0,
    orderId: 'ORD-2024-1841', slotId: null,
    events: [
      { time: '2024-06-12T12:30:00', event: 'mock.event.dispatched', icon: 'truck' },
      { time: '2024-06-12T13:55:00', event: 'mock.event.arrived', icon: 'map-pin' },
      { time: '2024-06-12T14:10:00', event: 'mock.event.loadingStarted', icon: 'loader' },
      { time: '2024-06-12T15:30:00', event: 'mock.event.departed', icon: 'check-circle' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0841.pdf', status: 'ready' },
      { type: 'Weigh Ticket', name: 'WT-2024-0605.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-12', plate: '6G1 7764',
    driver: { name: 'Vojtech Kopecky', phone: '+420 613 234 567' },
    company: customers[10].name, gate: 'PST', status: 'en-route',
    eta: '2024-06-15T16:00:00', arrivedAt: null, loadingStartedAt: null,
    material: 'Limestone PCC', targetWeight: 25.0, currentWeight: 0,
    orderId: 'ORD-2024-1836', slotId: 'slot-pst-1600',
    events: [
      { time: '2024-06-15T14:30:00', event: 'mock.event.dispatch', icon: 'truck' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0836.pdf', status: 'pending' },
    ],
  },
  {
    id: 'truck-13', plate: '3H8 2295',
    driver: { name: 'David Pokorny', phone: '+420 614 345 678' },
    company: customers[11].name, gate: 'CLS', status: 'departed',
    eta: '2024-06-14T08:00:00', arrivedAt: '2024-06-14T07:50:00', loadingStartedAt: '2024-06-14T08:05:00',
    material: 'Limestone GCC', targetWeight: 26.0, currentWeight: 26.0,
    orderId: 'ORD-2024-1835', slotId: null,
    events: [
      { time: '2024-06-14T06:00:00', event: 'mock.event.dispatched', icon: 'truck' },
      { time: '2024-06-14T07:50:00', event: 'mock.event.arrived', icon: 'map-pin' },
      { time: '2024-06-14T08:05:00', event: 'mock.event.loadingStarted', icon: 'loader' },
      { time: '2024-06-14T09:30:00', event: 'mock.event.departed', icon: 'check-circle' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0835a.pdf', status: 'ready' },
      { type: 'Weigh Ticket', name: 'WT-2024-0607.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-14', plate: '1I5 9981',
    driver: { name: 'Stanislav Ruzicka', phone: '+420 615 456 789' },
    company: customers[11].name, gate: 'PST', status: 'departed',
    eta: '2024-06-14T10:00:00', arrivedAt: '2024-06-14T09:55:00', loadingStartedAt: '2024-06-14T10:10:00',
    material: 'Limestone GCC', targetWeight: 26.0, currentWeight: 26.0,
    orderId: 'ORD-2024-1835', slotId: null,
    events: [
      { time: '2024-06-14T08:00:00', event: 'mock.event.dispatched', icon: 'truck' },
      { time: '2024-06-14T09:55:00', event: 'mock.event.arrived', icon: 'map-pin' },
      { time: '2024-06-14T10:10:00', event: 'mock.event.loadingStarted', icon: 'loader' },
      { time: '2024-06-14T11:30:00', event: 'mock.event.departed', icon: 'check-circle' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0835b.pdf', status: 'ready' },
      { type: 'Weigh Ticket', name: 'WT-2024-0608.pdf', status: 'ready' },
    ],
  },
  {
    id: 'truck-15', plate: '7J2 4478',
    driver: { name: 'Lubomir Hajek', phone: '+420 616 567 890' },
    company: customers[4].name, gate: 'CLS', status: 'en-route',
    eta: '2024-06-15T15:30:00', arrivedAt: null, loadingStartedAt: null,
    material: 'Limestone PCC', targetWeight: 23.5, currentWeight: 0,
    orderId: 'ORD-2024-1831', slotId: 'slot-cls-1500',
    events: [
      { time: '2024-06-15T14:00:00', event: 'mock.event.dispatch', icon: 'truck' },
    ],
    documents: [
      { type: 'CMR', name: 'CMR-2024-0831.pdf', status: 'pending' },
    ],
  },
];

// ── Loading Slots ───────────────────────────────────────────

export const loadingSlots = [
  // PST Gate
  { id: 'slot-pst-0600', gate: 'PST', startTime: '06:00', endTime: '08:00', truckId: 'truck-8', status: 'completed' },
  { id: 'slot-pst-0800', gate: 'PST', startTime: '08:00', endTime: '10:00', truckId: 'truck-1', status: 'occupied' },
  { id: 'slot-pst-1000', gate: 'PST', startTime: '10:00', endTime: '12:00', truckId: null, status: 'free' },
  { id: 'slot-pst-1200', gate: 'PST', startTime: '12:00', endTime: '14:00', truckId: 'truck-4', status: 'occupied' },
  { id: 'slot-pst-1400', gate: 'PST', startTime: '14:00', endTime: '16:00', truckId: 'truck-6', status: 'reserved' },
  { id: 'slot-pst-1600', gate: 'PST', startTime: '16:00', endTime: '18:00', truckId: 'truck-12', status: 'reserved' },
  // CLS Gate
  { id: 'slot-cls-0700', gate: 'CLS', startTime: '07:00', endTime: '09:00', truckId: 'truck-3', status: 'completed' },
  { id: 'slot-cls-0900', gate: 'CLS', startTime: '09:00', endTime: '11:00', truckId: 'truck-2', status: 'occupied' },
  { id: 'slot-cls-1100', gate: 'CLS', startTime: '11:00', endTime: '13:00', truckId: null, status: 'free' },
  { id: 'slot-cls-1300', gate: 'CLS', startTime: '13:00', endTime: '15:00', truckId: 'truck-5', status: 'reserved' },
  { id: 'slot-cls-1500', gate: 'CLS', startTime: '15:00', endTime: '17:00', truckId: 'truck-7', status: 'reserved' },
  { id: 'slot-cls-1700', gate: 'CLS', startTime: '17:00', endTime: '19:00', truckId: null, status: 'free' },
];

// ── Planning Data ───────────────────────────────────────────

export const materialColors = {
  'Limestone GCC': '#3b82f6',   // blue
  'Limestone PCC': '#8b5cf6',   // purple
  'By-product': '#f59e0b',      // amber
};

export const planningData = {
  lines: [
    {
      id: 'line-1', name: 'mock.line1', maxCapacity: 120,
      schedule: [
        { day: 'Po', material: 'Limestone GCC', grade: 'Omyacarb 2-AV', orderId: 'ORD-2024-1839', utilization: 85, energyTariff: 'offpeak', shift: 'night', plannedOutput: 680, actualOutput: 612 },
        { day: 'Út', material: 'Limestone PCC', grade: 'Omyafilm 707', orderId: 'ORD-2024-1825', utilization: 78, energyTariff: 'standard', shift: 'morning', plannedOutput: 620, actualOutput: 585 },
        { day: 'St', material: 'Limestone GCC', grade: 'Omyacarb 1-AV', orderId: 'ORD-2024-1835', utilization: 92, energyTariff: 'peak', shift: 'afternoon', plannedOutput: 720, actualOutput: 695 },
        { day: 'Čt', material: 'By-product', grade: 'CaCO3 powder', orderId: 'ORD-2024-1824', utilization: 55, energyTariff: 'negative', shift: 'midday', plannedOutput: 440, actualOutput: 410 },
        { day: 'Pá', material: 'Limestone PCC', grade: 'Omyacarb 10-AV', orderId: 'ORD-2024-1831', utilization: 88, energyTariff: 'peak', shift: 'afternoon', plannedOutput: 700, actualOutput: null },
        { day: 'So', material: null, grade: null, orderId: null, utilization: 0, energyTariff: null, shift: null, plannedOutput: 0, actualOutput: 0 },
        { day: 'Ne', material: 'Limestone GCC', grade: 'Omyacarb 2-AV', orderId: 'ORD-2024-1847', utilization: 45, energyTariff: 'offpeak', shift: 'night', plannedOutput: 360, actualOutput: null },
      ],
    },
    {
      id: 'line-2', name: 'mock.line2', maxCapacity: 100,
      schedule: [
        { day: 'Po', material: 'Limestone PCC', grade: 'Omyacarb 5-GU', orderId: 'ORD-2024-1846', utilization: 72, energyTariff: 'offpeak', shift: 'night', plannedOutput: 580, actualOutput: 540 },
        { day: 'Út', material: 'By-product', grade: 'CaCO3 powder', orderId: 'ORD-2024-1842', utilization: 58, energyTariff: 'standard', shift: 'morning', plannedOutput: 460, actualOutput: 430 },
        { day: 'St', material: 'Limestone GCC', grade: 'Hydrocarb 95-T', orderId: 'ORD-2024-1838', utilization: 81, energyTariff: 'negative', shift: 'midday', plannedOutput: 650, actualOutput: 620 },
        { day: 'Čt', material: 'Limestone PCC', grade: 'Omyacarb 10-AV', orderId: 'ORD-2024-1836', utilization: 76, energyTariff: 'peak', shift: 'afternoon', plannedOutput: 610, actualOutput: 580 },
        { day: 'Pá', material: null, grade: null, orderId: null, utilization: 0, energyTariff: null, shift: null, plannedOutput: 0, actualOutput: 0 },
        { day: 'So', material: null, grade: null, orderId: null, utilization: 0, energyTariff: null, shift: null, plannedOutput: 0, actualOutput: 0 },
        { day: 'Ne', material: 'Limestone GCC', grade: 'Omyacarb 2-AV', orderId: 'ORD-2024-1833', utilization: 52, energyTariff: 'offpeak', shift: 'night', plannedOutput: 420, actualOutput: null },
      ],
    },
    {
      id: 'line-3', name: 'mock.line3', maxCapacity: 90,
      schedule: [
        { day: 'Po', material: 'By-product', grade: 'CaCO3 powder', orderId: 'ORD-2024-1841', utilization: 48, energyTariff: 'standard', shift: 'morning', plannedOutput: 380, actualOutput: 350 },
        { day: 'Út', material: 'Limestone GCC', grade: 'Omyacarb 2-AV', orderId: 'ORD-2024-1837', utilization: 89, energyTariff: 'peak', shift: 'afternoon', plannedOutput: 710, actualOutput: 680 },
        { day: 'St', material: 'Limestone PCC', grade: 'Omyafilm 707', orderId: 'ORD-2024-1827', utilization: 73, energyTariff: 'negative', shift: 'midday', plannedOutput: 580, actualOutput: 550 },
        { day: 'Čt', material: 'By-product', grade: 'CaCO3 powder', orderId: 'ORD-2024-1824', utilization: 62, energyTariff: 'offpeak', shift: 'night', plannedOutput: 500, actualOutput: 470 },
        { day: 'Pá', material: 'Limestone GCC', grade: 'Hydrocarb 95-T', orderId: 'ORD-2024-1830', utilization: 95, energyTariff: 'peak', shift: 'afternoon', plannedOutput: 760, actualOutput: null },
        { day: 'So', material: 'Limestone PCC', grade: 'Omyacarb 5-GU', orderId: 'ORD-2024-1829', utilization: 68, energyTariff: 'standard', shift: 'morning', plannedOutput: 540, actualOutput: null },
        { day: 'Ne', material: null, grade: null, orderId: null, utilization: 0, energyTariff: null, shift: null, plannedOutput: 0, actualOutput: 0 },
      ],
    },
  ],
  // OTE spotové ceny (typický pracovní den, jaro 2026, bez DPH a distribuce).
  // Od 1. 10. 2025 je denní trh OTE čtvrthodinový. Negativní cena = přebytek FVE
  // v poledne (50 dnů záporných cen v 2024, minimum −138,75 EUR/MWh).
  energyTariffs: [
    { period: '00:00–08:00', type: 'offpeak', rate: 1000, unit: 'CZK/MWh' },
    { period: '08:00–10:00', type: 'standard', rate: 1600, unit: 'CZK/MWh' },
    { period: '10:00–13:00', type: 'negative', rate: -500, unit: 'CZK/MWh' },
    { period: '13:00–20:00', type: 'peak', rate: 2200, unit: 'CZK/MWh' },
    { period: '20:00–24:00', type: 'offpeak', rate: 1000, unit: 'CZK/MWh' },
  ],
};

// ── Dashboard Aggregations ──────────────────────────────────

export const dashboardData = {
  kpis: {
    todayOutput: { value: 1847, target: 2400, unit: 't', trend: 12, sparkline: [1720, 1650, 1800, 1780, 1900, 1650, 1847] },
    utilization: { value: 73, target: 85, unit: '%', trend: 0, sparkline: [68, 71, 75, 72, 74, 65, 73] },
    oee: { value: 77.6, target: 85, unit: '%', trend: 2.1, sparkline: [72, 74, 78, 75, 79, 70, 77.6] },
    loadings: { completed: 34, total: 80, trend: 0 },
    qualityRate: { value: 99.2, target: 99.5, unit: '%', trend: -0.1, sparkline: [99.4, 99.1, 99.3, 99.2, 99.5, 99.0, 99.2] },
    energyCost: { value: 12450, target: 15000, unit: 'CZK', trend: -3.2, sparkline: [14200, 13800, 12900, 13100, 12700, 11500, 12450] },
  },
  productionWeek: [
    { day: 'Po', actual: 1720, target: 2400 },
    { day: 'Út', actual: 1650, target: 2400 },
    { day: 'St', actual: 1800, target: 2400 },
    { day: 'Čt', actual: 1780, target: 2400 },
    { day: 'Pá', actual: 1900, target: 2400 },
    { day: 'So', actual: 1650, target: 1800 },
    { day: 'Ne', actual: 1847, target: 2000 },
  ],
  productionHourly: [
    { hour: '06:00', output: 80 }, { hour: '07:00', output: 140 }, { hour: '08:00', output: 180 },
    { hour: '09:00', output: 210 }, { hour: '10:00', output: 220 }, { hour: '11:00', output: 200 },
    { hour: '12:00', output: 170 }, { hour: '13:00', output: 190 }, { hour: '14:00', output: 210 },
    { hour: '15:00', output: 205 }, { hour: '16:00', output: 195 }, { hour: '17:00', output: 0 },
    { hour: '18:00', output: 0 },
  ],
  lineUtilization: [
    { name: 'mock.line1', utilization: 80, target: 85 },
    { name: 'mock.line2', utilization: 65, target: 80 },
    { name: 'mock.line3', utilization: 55, target: 75 },
  ],
  shiftData: {
    morning: { output: 920, target: 1000, hours: '06:00–14:00', workers: 12 },
    afternoon: { output: 580, target: 800, hours: '14:00–22:00', workers: 10 },
    night: { output: 347, target: 600, hours: '22:00–06:00', workers: 8 },
  },
  alerts: [
    { id: 'al-1', type: 'error', message: 'mock.alert.line2Overload', timestamp: '2024-06-15T10:15:00', source: 'line-2', sourceType: 'planning', dismissed: false },
    { id: 'al-2', type: 'error', message: 'mock.alert.noInfoLoadings', timestamp: '2024-06-15T12:55:00', source: 'arrivals', sourceType: 'trucks', dismissed: false },
    { id: 'al-3', type: 'success', message: 'mock.alert.dispatchOk', timestamp: '2024-06-15T10:25:00', source: 'node-dispatch', sourceType: 'supply-chain', dismissed: false },
    { id: 'al-4', type: 'warning', message: 'mock.alert.crusherBearingTemp', timestamp: '2024-06-15T09:45:00', source: 'node-crusher', sourceType: 'supply-chain', dismissed: false },
    { id: 'al-5', type: 'info', message: 'mock.alert.tariffPeakSwitch', timestamp: '2024-06-15T13:45:00', source: 'energy', sourceType: 'planning', dismissed: false },
    { id: 'al-6', type: 'warning', message: 'mock.alert.orderPending', timestamp: '2024-06-15T08:30:00', source: 'ORD-2024-1845', sourceType: 'orders', dismissed: false },
    { id: 'al-7', type: 'info', message: 'mock.alert.truckEta45', timestamp: '2024-06-15T13:45:00', source: 'truck-6', sourceType: 'trucks', dismissed: true },
  ],
};

// ── Weigh Bridge ────────────────────────────────────────────

export const weighBridge = {
  status: 'active',
  currentTruck: 'truck-4',
  lastReading: { weight: 13.2, unit: 't', timestamp: '2024-06-15T12:50:00', type: 'weigh-in' },
};

// ── Lookup Helpers ──────────────────────────────────────────

export function getOrderById(id) {
  return orders.find(o => o.id === id) || null;
}

export function getTruckById(id) {
  return trucks.find(t => t.id === id) || null;
}

export function getNodeById(id) {
  return supplyChainNodes.find(n => n.id === id) || null;
}

export function getTrucksForOrder(orderId) {
  return trucks.filter(t => t.orderId === orderId);
}

export function getOrdersForNode(nodeId) {
  const node = getNodeById(nodeId);
  if (!node) return [];
  return node.linkedOrders.map(getOrderById).filter(Boolean);
}

export function getSlotForTruck(truckId) {
  return loadingSlots.find(s => s.truckId === truckId) || null;
}

export function getTrucksForGate(gate) {
  return trucks.filter(t => t.gate === gate && ['waiting', 'weigh-in', 'loading', 'en-route'].includes(t.status));
}

export function getActiveAlerts() {
  return dashboardData.alerts.filter(a => !a.dismissed);
}

export function getOrdersByStatus(status) {
  return orders.filter(o => o.status === status);
}

// Status display helpers
export const orderStatuses = ['pending', 'confirmed', 'in-production', 'produced', 'dispatched', 'delivered'];
export const truckStatuses = ['en-route', 'waiting', 'weigh-in', 'loading', 'weigh-out', 'departed'];

export const orderStatusLabels = {
  'pending': 'Čeká', 'confirmed': 'Potvrzeno', 'in-production': 'Ve výrobě',
  'produced': 'Vyrobeno', 'dispatched': 'Expedováno', 'delivered': 'Doručeno',
};

export const truckStatusLabels = {
  'en-route': 'Na cestě', 'waiting': 'Čeká', 'weigh-in': 'Vážení-in',
  'loading': 'Nakládka', 'weigh-out': 'Vážení-out', 'departed': 'Odjel',
};

// ── Driver Messages (Communication Module) ────────────────
export const driverMessages = [
  { id: 'msg-1', truckId: 'truck-1', direction: 'driver', text: 'mock.dm.hourAway', timestamp: '2024-06-15T09:15:00' },
  { id: 'msg-2', truckId: 'truck-1', direction: 'plant', text: 'mock.dm.gateReady', timestamp: '2024-06-15T09:20:00' },
  { id: 'msg-3', truckId: 'truck-1', direction: 'driver', text: 'mock.dm.arriveIn45', timestamp: '2024-06-15T09:30:00' },
  { id: 'msg-4', truckId: 'truck-2', direction: 'plant', text: 'mock.dm.holdSlot', timestamp: '2024-06-15T08:45:00' },
  { id: 'msg-5', truckId: 'truck-2', direction: 'driver', text: 'mock.dm.waitingParking', timestamp: '2024-06-15T08:50:00' },
  { id: 'msg-6', truckId: 'truck-2', direction: 'plant', text: 'mock.dm.slotFree', timestamp: '2024-06-15T09:30:00' },
  { id: 'msg-7', truckId: 'truck-3', direction: 'driver', text: 'mock.dm.atGate', timestamp: '2024-06-15T10:00:00' },
  { id: 'msg-8', truckId: 'truck-3', direction: 'plant', text: 'mock.dm.goToScale', timestamp: '2024-06-15T10:02:00' },
  { id: 'msg-9', truckId: 'truck-4', direction: 'driver', text: 'mock.dm.loadingDone', timestamp: '2024-06-15T12:30:00' },
  { id: 'msg-10', truckId: 'truck-4', direction: 'plant', text: 'mock.dm.goToExitScale', timestamp: '2024-06-15T12:32:00' },
  { id: 'msg-11', truckId: 'truck-5', direction: 'plant', text: 'mock.dm.delay30', timestamp: '2024-06-15T11:00:00' },
  { id: 'msg-12', truckId: 'truck-5', direction: 'driver', text: 'mock.dm.arriveLater', timestamp: '2024-06-15T11:05:00' },
  { id: 'msg-13', truckId: 'truck-6', direction: 'driver', text: 'mock.dm.eta45', timestamp: '2024-06-15T13:00:00' },
  { id: 'msg-14', truckId: 'truck-6', direction: 'plant', text: 'mock.dm.preparingCLS', timestamp: '2024-06-15T13:05:00' },
];

// ────────────────────────────────────────────────────────────
// Production details — fractions, packaging, silos, deps
// Added per Pomezí meeting 29-04-2026 (P0 zadání).
// Lookup table per (line + day) so we don't need to mutate
// the 21-slot planningData array.
// ────────────────────────────────────────────────────────────

// Cycle multiplier — finer fraction → longer milling time per tonne.
export const fractions = [
  { id: 'sand',     labelKey: 'planning.fraction.sand',     cycleMultiplier: 1.0, color: '#a8a29e' }, // stone-400
  { id: 'fine',     labelKey: 'planning.fraction.fine',     cycleMultiplier: 1.3, color: '#94a3b8' }, // slate-400
  { id: 'standard', labelKey: 'planning.fraction.standard', cycleMultiplier: 1.6, color: '#64748b' }, // slate-500
  { id: 'powder',   labelKey: 'planning.fraction.powder',   cycleMultiplier: 2.2, color: '#475569' }, // slate-600
];

export const packagingLines = [
  { id: 'big-bag', labelKey: 'planning.packaging.bigBag', capacityTph: 12, loadingMinPerTruck: 35 },
  { id: 'bag25',   labelKey: 'planning.packaging.bag25',  capacityTph: 5,  loadingMinPerTruck: 42 },
  { id: 'bag50',   labelKey: 'planning.packaging.bag50',  capacityTph: 7,  loadingMinPerTruck: 38 },
  { id: 'bulk',    labelKey: 'planning.packaging.bulk',   capacityTph: 40, loadingMinPerTruck: 16 },
];

// Silos — 6 units with different capacities + fill times (depending on
// production capacity AND material fraction).
// productionTph = how many t/h flow into the silo from production right now.
// queuedTrucks = trucks scheduled to pick up from this silo (ETA in minutes).
export const silos = [
  { id: 'silo-1', name: 'Silo 1 — GCC fine',     capacityT: 250, contentT: 180, fillTimeMinPerT: 4.2, productionTph: 24, materialId: 'Limestone GCC',  fractionId: 'fine',     queuedTrucks: [{ id: 'TR-A', etaMin: 90,  takeT: 28 }] },
  { id: 'silo-2', name: 'Silo 2 — GCC powder',   capacityT: 180, contentT: 168, fillTimeMinPerT: 6.8, productionTph: 18, materialId: 'Limestone GCC',  fractionId: 'powder',   queuedTrucks: [{ id: 'TR-B', etaMin: 35,  takeT: 25 }] }, // KOLIZE: full in ~40min, truck in 35min — borderline
  { id: 'silo-3', name: 'Silo 3 — PCC standard', capacityT: 200, contentT:  74, fillTimeMinPerT: 5.1, productionTph: 22, materialId: 'Limestone PCC',  fractionId: 'standard', queuedTrucks: [] },
  { id: 'silo-4', name: 'Silo 4 — PCC fine',     capacityT: 220, contentT: 142, fillTimeMinPerT: 4.5, productionTph: 20, materialId: 'Limestone PCC',  fractionId: 'fine',     queuedTrucks: [{ id: 'TR-C', etaMin: 240, takeT: 30 }] },
  { id: 'silo-5', name: 'Silo 5 — GCC sand',     capacityT: 300, contentT: 264, fillTimeMinPerT: 3.0, productionTph: 32, materialId: 'Limestone GCC',  fractionId: 'sand',     queuedTrucks: [{ id: 'TR-D', etaMin: 80,  takeT: 30 }] }, // plné za ~67min, auto 80min → KOLIZE
  { id: 'silo-6', name: 'Silo 6 — By-product',   capacityT: 150, contentT:  88, fillTimeMinPerT: 4.0, productionTph: 12, materialId: 'By-product',     fractionId: 'standard', queuedTrucks: [] },
];

// Returns minutes until silo is full at current production rate.
export function siloMinutesToFull(silo) {
  const remainingT = silo.capacityT - silo.contentT;
  if (silo.productionTph <= 0) return Infinity;
  return Math.round((remainingT / silo.productionTph) * 60);
}

// Returns { collision: boolean, minutesAhead } — true if silo fills BEFORE
// the next scheduled truck arrives (production stops + overflow risk).
export function siloCollision(silo) {
  if (silo.queuedTrucks.length === 0 && silo.contentT / silo.capacityT > 0.85) {
    return { collision: true, reason: 'no-truck', minutesAhead: siloMinutesToFull(silo) };
  }
  if (silo.queuedTrucks.length === 0) return { collision: false };
  const nextTruck = silo.queuedTrucks[0];
  const fillIn = siloMinutesToFull(silo);
  if (fillIn < nextTruck.etaMin) {
    return { collision: true, reason: 'truck-too-late', minutesAhead: nextTruck.etaMin - fillIn, truck: nextTruck };
  }
  return { collision: false };
}

// Per-slot extra metadata. Key = `${lineId}/${day}`.
// `linkedTo` = array of slot keys whose production must run in parallel
// (e.g. PCC standard requires running GCC by-product on another line).
export const slotDetails = {
  // Line 1
  'line-1/Po': { fractionId: 'standard', packagingLineId: 'big-bag', linkedTo: [] },
  'line-1/Út': { fractionId: 'powder',   packagingLineId: 'bag25',   linkedTo: ['line-3/Út'] },
  'line-1/St': { fractionId: 'fine',     packagingLineId: 'big-bag', linkedTo: [] },
  'line-1/Čt': { fractionId: 'powder',   packagingLineId: 'bulk',    linkedTo: ['line-3/Čt'] },
  'line-1/Pá': { fractionId: 'standard', packagingLineId: 'bag50',   linkedTo: [] },
  'line-1/So': null,
  'line-1/Ne': { fractionId: 'standard', packagingLineId: 'bulk',    linkedTo: [] },
  // Line 2
  'line-2/Po': { fractionId: 'fine',     packagingLineId: 'bag25',   linkedTo: [] },
  'line-2/Út': { fractionId: 'standard', packagingLineId: 'bulk',    linkedTo: [] },
  'line-2/St': { fractionId: 'sand',     packagingLineId: 'bulk',    linkedTo: [] },
  'line-2/Čt': { fractionId: 'powder',   packagingLineId: 'big-bag', linkedTo: ['line-3/Čt'] },
  'line-2/Pá': null,
  'line-2/So': null,
  'line-2/Ne': { fractionId: 'sand',     packagingLineId: 'bulk',    linkedTo: [] },
  // Line 3
  'line-3/Po': { fractionId: 'standard', packagingLineId: 'bulk',    linkedTo: [] },
  'line-3/Út': { fractionId: 'standard', packagingLineId: 'bag50',   linkedTo: ['line-1/Út'] },
  'line-3/St': { fractionId: 'powder',   packagingLineId: 'big-bag', linkedTo: [] },
  'line-3/Čt': { fractionId: 'standard', packagingLineId: 'bulk',    linkedTo: ['line-1/Čt', 'line-2/Čt'] },
  'line-3/Pá': { fractionId: 'sand',     packagingLineId: 'bulk',    linkedTo: [] },
  'line-3/So': { fractionId: 'fine',     packagingLineId: 'bag25',   linkedTo: [] },
  'line-3/Ne': null,
};

// Live ANDON status of production lines — drives Visual Factory tiles.
// statusAndon: 'green' (≥90% target), 'yellow' (60-89%), 'red' (<60% or stop)
export const lineStatus = [
  { id: 'line-1', name: 'mock.line1', currentMaterial: 'GCC fine',  currentFraction: 'fine',     currentTph: 95, targetTph: 100, statusAndon: 'green',  downtimeMin: 0,   stopReason: null },
  { id: 'line-2', name: 'mock.line2', currentMaterial: 'PCC powder',currentFraction: 'powder',   currentTph: 52, targetTph: 80,  statusAndon: 'yellow', downtimeMin: 134, stopReason: 'mock.line.stopReason.slowMillVibration' },
  { id: 'line-3', name: 'mock.line3', currentMaterial: 'GCC sand',  currentFraction: 'sand',     currentTph: 76, targetTph: 80,  statusAndon: 'green',  downtimeMin: 0,   stopReason: null },
];

// Daily aggregate target (drives "Are we on plan?" big banner).
export const dailyPlan = {
  targetT: 2000,
  producedT: 1620,
  shiftRemainingHours: 7.4,
  daysSinceIncident: 127,
  trucksLoadedToday: 34,
  trucksTargetToday: 80,
  trucksToCZ: 12,
  trucksToPL: 22,
};

// Active maintenance work-order (gets shown on Visual Factory).
export const maintenanceActive = [
  { id: 'mt-1', equipment: 'mock.equipment.crusher', etaHour: '14:30', assignee: 'Novák', priority: 'high' },
];

// Lookup helpers
export function getSlotDetails(lineId, day) {
  return slotDetails[`${lineId}/${day}`] || null;
}

export function getFraction(id) {
  return fractions.find(f => f.id === id);
}

export function getPackagingLine(id) {
  return packagingLines.find(p => p.id === id);
}

